// Notice the Home shows on returning from the wizard (see pages/Home, which
// reads it from sessionStorage). It lives here, and not in index.tsx, so that
// the Home can import it without loading the whole wizard (and without a cycle:
// the wizard is painted over the Home).
export const SESSION_STORAGE_ARCHIVE_SUCCESS_KEY = 'ARCHIVE_SUCCESS';

// Limits imposed by the backend (services/documentPages.js). They are checked
// here too to warn before uploading anything, but the final word is the
// server's, whose messages are translated in api.ts.
export const MAX_PAGES_PER_DOCUMENT = 10;
export const MAX_BYTES_PER_FILE = 20 * 1024 * 1024;
export const MAX_MEGABYTES_PER_FILE = 20;

export const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
];

export const ACCEPT_ATTRIBUTE = 'application/pdf,image/jpeg,image/png';
